export class FormData {
    constructor() {
        this.data = {
            coverType: '',
            area: '',
            startDate: '',
            groupType: '',
            AYG: 0,
            AMD: 0,
            AMR: 0,
            DCH: 0,
            INF: 0,
            sourceCode: 'TESINT',
            endDate: '',
            numberOfTripDays: '31',
        };
    }
    get(key) {
        return this.data[key];
    }
    set(key, value) {
        this.data[key] = value;
    }
    getAll() {
        return this.data;
    }
    remove(key) {
        delete this.data[key];
    }
}
